import React, { useState } from 'react';
import { ListGroup, FormControl, Button } from 'react-bootstrap';

const MarketsColumn = ({ markets, onSelectMarket, selectedMarkets, setSelectedMarkets }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!markets?.length) {
    return (
      <div>
        <h5>markets</h5>
        <p>No markets</p>
      </div>
    );
  }

  const handleSelectAllMarkets = () => {
    const allFilteredMarkets = markets.map(market => ({
        name: market,
        ref: market,
    }));
    setSelectedMarkets(allFilteredMarkets);
  }

  const handleClearAllMarkets = () => {
    setSelectedMarkets([])
  }

  return (
    <div>
      <h5>Markets</h5>
      <FormControl 
        placeholder="Search markets..." 
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '10px' }}
        value={searchTerm}
      />
      <Button variant="outline-dark" style={{ margin: '0 10px 10px 0' }} size="sm" onClick={handleSelectAllMarkets}>Select all</Button>
      <Button variant="outline-dark" style={{ margin: '0 0 10px 10px' }} size="sm" onClick={handleClearAllMarkets}>Clear all</Button>
      <ListGroup style={{ maxHeight: '500px', overflowY: 'scroll', border: '1px solid #888' }}>
        {markets.map((market, index) => (
          <ListGroup.Item 
            key={`${market}-${index}`} 
            action 
            onClick={() => onSelectMarket({name: market, ref: market})}
            active={selectedMarkets.some(item => market === item)}
          >
            {market}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default MarketsColumn;
